import { useMemo } from "react";

import useCampaignEmailStore from "@store/campaignStore";
import { useUserStore } from "@store/userStore";

const getReviewCampaignSlideButtonText = (isAuthenticated: boolean, isScheduled: boolean) => {
  if (!isAuthenticated) {
    return "Connect Email";
  }
  if (isScheduled) {
    return "Schedule Campaign";
  }
  return "Send Campaign";
};

const useCreateCampaignSlides = () => {
  const user = useUserStore();

  const { sendOptions } = useCampaignEmailStore();

  return useMemo(
    () => [
      {
        backButtonTooltip: "Back to Technology",
        isBackButtonDisabled: false,
        isNextButtonDisabled: false,
        name: "Account Setup",
        nextButtonText: "Campaign Setup",
        nextButtonTooltip: "Add technology information to your campaign.",
        slideFields: ["jobTitle", "organizationName", "emailSignature"],
        splatString: "account",
      },
      {
        backButtonTooltip: "Edit your account details.",
        isBackButtonDisabled: false,
        isNextButtonDisabled: false,
        name: "Campaign Setup",
        nextButtonText: "Compose Email",
        nextButtonTooltip: "Create your Campaign email template.",
        slideFields: ["name", "technologySummary"],
        splatString: "setup",
      },
      {
        backButtonTooltip: "Edit your Campaign setup.",
        isBackButtonDisabled: false,
        isNextButtonDisabled: false,
        name: "Compose Email",
        nextButtonText: "Personalize Emails",
        nextButtonTooltip: "Personalize each of your Campaign emails.",
        slideFields: ["emailTemplate"],
        splatString: "compose",
      },
      {
        backButtonTooltip: "Edit your email template.",
        isBackButtonDisabled: false,
        isNextButtonDisabled: false,
        name: "Personalize Emails",
        nextButtonText: "Review Campaign",
        nextButtonTooltip: "Review your Campaign one last time before sending.",
        slideFields: [],
        splatString: "personalize",
      },
      {
        backButtonTooltip: "Personalize each of your Campaign emails.",
        isBackButtonDisabled: false,
        isNextButtonDisabled: false,
        name: "Review Campaign",
        nextButtonText: getReviewCampaignSlideButtonText(!!user.nylasAuthenticated, sendOptions === "schedule"),
        nextButtonTooltip: "Looking good? Send out your Campaign!",
        slideFields: [],
        splatString: "review",
      },
      {
        backButtonTooltip: "",
        isBackButtonDisabled: true,
        isNextButtonDisabled: false,
        name: "Campaign Sent Confirmation",
        nextButtonText: "View Technology",
        nextButtonTooltip: "View the technology you just created a campaign for.",
        slideFields: [],
        splatString: "confirmation",
      },
    ],
    [user.nylasAuthenticated, sendOptions],
  );
};

export default useCreateCampaignSlides;
